import script from "./Announcement.vue?vue&type=script&setup=true&lang=js"
export * from "./Announcement.vue?vue&type=script&setup=true&lang=js"

import "./Announcement.vue?vue&type=style&index=0&id=beddd0fe&scoped=true&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-beddd0fe"]])

export default __exports__